import type { ReactElement } from 'react';
import { Flex } from '@fastnorth/kraken/components/layout';
import type { ParticipantSearchRow } from '../../../types/events';
import { useApp } from '../../../hooks/AppProvider.tsx';
import ParticipantSummaryDetail from './components/ParticipantSummaryDetail.tsx';

export type ParticipantSearchItemProps = {
  participant: ParticipantSearchRow;
  closeSearch?: () => void;
  resultSubEventId: number;
};

export const ParticipantSearchItem = ({
  participant,
  resultSubEventId,
  closeSearch,
}: ParticipantSearchItemProps): ReactElement | null => {
  const [{ event }] = useApp();

  if (!event) return null;
  return (
    <li key={`participant-${participant.id}`}>
      <Flex className={'w-full px-6'}>
        <ParticipantSummaryDetail
          includeRaceName
          closeSearch={closeSearch}
          resultsSubEventId={resultSubEventId}
          followTogglePlacement="right"
          participant={participant}
        />
      </Flex>
    </li>
  );
};

export default ParticipantSearchItem;
